const subjects = [
    { label: 'Introdução a computação', value: 'ic' },
    { label: 'Redes de Computadores', value: 'rd' },
    { label: 'Inteligencia Artificial', value: 'ia' },
    { label: 'Linguagens e paradigmas de programação', value: 'lp' },
    { label: 'Validação de teste', value: 'vt' },
    { label: 'Outras', value: 'others' }
];

export default subjects;